export const name = 'tpaCommons' as const
export const TpaHandlersManagerSymbol = Symbol('TpaHandlersManager')
export const MasterPageTpaPropsCacheSymbol = Symbol('TpaPropsCache')
